var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83325 8.33333V11.6667H8.33325V17.5H11.6666V11.6667H14.1666L14.9999 8.33333H11.6666V6.66667C11.6666 6.44565 11.7544 6.23369 11.9107 6.07741C12.0669 5.92113 12.2789 5.83333 12.4999 5.83333H14.9999V2.5H12.4999C11.3948 2.5 10.335 2.93899 9.55364 3.72039C8.77224 4.50179 8.33325 5.5616 8.33325 6.66667V8.33333H5.83325Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/FacebookIcon.dd86f41bb32fef0a4dc3a3c4827e1822.svg";
export { ForwardRef as ReactComponent };